const getDefaultState = () => {
  return {
    loading: false
  }
}

const state = getDefaultState()

const getters = {
  getLoadingStatus (state) {
    return state.loading
  }
}

const actions = {
  updateLoadingAction (context, payload) {
    context.commit('updateLoadingStatus', payload)
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  updateLoadingStatus (state, status) {
    if (state.loading) {
      state.loading = status
    } else {
      state.loading = status
    }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
